import styled from "@emotion/styled/macro";
import { colors, views } from "../../../../common/styles/theme.styles";

export const VaultSearchComponentWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    position: relative;
    
    ${({ isAssetVaultTab }) => isAssetVaultTab ? 
        `
            padding: 0;
        `
    :
        `
            padding: 0px 40px 2px 0px;
            width: 100%;
            flex: 1;
            min-width: 200px;
        `
    }

    ${views.tablet} {
        padding: 0;
        flex-direction: column;
        align-items: stretch;
        gap: 12px;
    }
`;

export const VaultSearchTitle = styled.div`
    color: var(--Dark-Gray-1, #1A1B1D);
    text-align: center;
    font-size: 22px;
    font-style: normal;
    font-weight: 700;
    line-height: 115%; /* 25.3px */
    letter-spacing: -1.32px;
`

export const VaultSearchBarWrapper = styled.div`
    display: flex;
    width: 100%;
    max-width: ${({ isAssetVaultTab, isMobile }) =>
        isMobile ? '100%' :
            isAssetVaultTab ? '280px' : '380px'
    };
    min-width: ${({ isMobile }) => isMobile ? '200px' : '250px'};
    flex-shrink: 1;
    height: ${({ isAssetVaultTab, isMobile }) =>
        isMobile ? '36px' :
            isAssetVaultTab ? '40px' : '44px'
    };
    padding-left: 20px;
    align-items: center;
    gap: 8px;
    position: relative;

    border-radius: ${({ isMobile }) => isMobile ? '12px' : '26px'};
    border: 1px solid #D1D4DA;
    background: rgba(255, 255, 255, 0.50);
    };
    transition: all 0.3s ease;
    
    :hover {
        ${({ isSearchDisabled }) => !isSearchDisabled && `
            border: 1px solid ${colors.darkGray1};
        `}
    }

    ${({ isSearchDisabled }) => isSearchDisabled && `
        opacity: 0.5;
        pointer-events: none;
    `}
    
    ${({ isDropdownOpen, isMobile }) => isDropdownOpen && `
        border: 1px solid ${colors.darkGray1};
        z-index: 1000;
        background: ${isMobile ? '#111213' : 'white'};
    `}
    
    /* Responsive adjustments for different screen sizes */
    @media (max-width: 1200px) {
        max-width: ${({ isAssetVaultTab }) => isAssetVaultTab ? '280px' : '320px'};
    }
    
    @media (max-width: 1024px) {
        max-width: ${({ isAssetVaultTab }) => isAssetVaultTab ? '260px' : '280px'};
        min-width: 200px;
    }
    
    @media (max-width: 900px) {
        max-width: ${({ isAssetVaultTab }) => isAssetVaultTab ? '240px' : '250px'};
        min-width: 180px;
    }
    
    /* Mobile responsive adjustments */
    @media (max-width: 768px) {
        width: 100%;
        max-width: 100%;
        min-width: unset;
        height: 36px;
        margin-bottom: ${({ isMobile }) => isMobile ? '0' : '12px'};
        border-radius: 12px;
        border: 1px solid #3B3F46;
        background: #111213;
    }
`;

export const SearchIcon = styled.div`
    display: flex;
    align-items: center;
    svg {
        width: 16px;
        height: 16px;
        circle, line {
            stroke: #9097A3;
        }
    }
    
    /* Mobile specific styling */
    @media (max-width: 768px) {
        svg {
            circle, line {
                stroke: #9097A3;
            }
        }
    }
`;

export const SearchInput = styled.input`
    flex: 1;
    border: none;
    outline: none;
    background: transparent;
    font-size: 14px;
    color: #1A1B1D;
    
    &::placeholder {
        color: #9097A3;
        font-weight: 450;
        line-height: 1.265;
    }
`;

export const ClearButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    border: none;
    background: #9097A3;
    border-radius: 50%;
    cursor: pointer;
    color: white;
    font-size: 12px;
    font-weight: bold;
    margin-right: 16px;
    
    &:hover {
        background: #7A8189;
    }
`;